import functions from "./functions.js";

$(function () {

    const $form = $('.contact-form');
    const form = $form[0];

    const lang = functions.getLang();
    let output = '';

    if($('gmp-map').length) {
        window.loadGoogleMaps();
    }

    if (!form) {
        return;
    }
    
    $form.on('submit', e => {
        e.preventDefault();

        $('.submit-btn').addClass('d-none');
        $('.contact-spinner').removeClass('d-none');
        $('.contact-spinner').addClass('d-flex');

        let params = {};
        $.each($form.serializeArray(), function (i, field) {
            params[field.name] = field.value;
        });

        params['language'] = functions.getLang();
        params['recaptchaType'] = 'enterprise';

        grecaptcha.enterprise.ready(function () {
            grecaptcha.enterprise.execute(functions.getRecaptchaKey(), { action: 'contact' }).then(function (token) {
                params['gRecaptchaToken'] = token;
                params = functions.getDataForUrl(params);

                $.post('/services/contact', params).then(response => {
                    
                    $('#contact-modal').modal('show');
                    $(".contact-response").html(response.data);

                    $('.submit-btn').removeClass('d-none');
                    $('.contact-spinner').removeClass('d-flex');
                    $('.contact-spinner').addClass('d-none');

                    //setTimeout(() => { $(".contact-response").addClass('d-none') }, 3000);
                    setTimeout(() => { $('#contact-modal').modal('hide') }, 6000);

                    if (response.status == true) {
                        form.reset();
                    }
                });
            });
        });

    });

});